import React, { useContext } from 'react';
import { I18nextProvider } from 'react-i18next';
import { i18n } from '../i18n';
import { resolveLanguageData } from './languageContextConfig';
import { useLanguagePresentation } from './useLanguagePresentation';

const LanguageContext = React.createContext({
  lang: 'en',
  preference: '',
  currentLangData: resolveLanguageData('en'),
  switchLang: async (_language: string) => false,
  loading: false,
  saving: false,
  error: '',
  userId: '',
  retry: () => {}
});
export default LanguageContext;
export const useLanguage = () => useContext(LanguageContext);
export function LangProvider({ children }: { children: React.ReactNode }) {
  const value = useLanguagePresentation();
  return (
    <I18nextProvider i18n={i18n}>
      <LanguageContext.Provider value={value}>
        {children}
      </LanguageContext.Provider>
    </I18nextProvider>
  );
}
